export const urlClubCodeMap: { [club: string]: string } = {
  '004': 'calif',
  '252': 'texas',
  '601': 'newmexico',
  '018': 'hawaii',
  '036': 'northernnewengland',
  '001': 'alabama',
  '215': 'eastcentral',
  '258': 'tidewater',
  '065': 'autoclubmo',
};
